import { useMemo } from "react";
import {
  useEntitySelector,
  type EntitySelectorSectionLabelAction,
} from "@salestrak/ui";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { usePermission } from "#app/lib/hooks/use-permission";

/**
 * The "Edit" door on a type pool's section label, for a viewer whose key
 * admits them to that Types settings page (the same key that reveals the
 * settings row); `undefined` hides it for everyone else. Going through the
 * door closes the picker first: a popup left open under the page it navigated
 * to is answering a question the page took over. Must render inside an
 * `EntitySelector` — it reads the selector's open state.
 */
export function useManageTypesLabelAction(
  settingsPath: string,
): EntitySelectorSectionLabelAction | undefined {
  const canManageTypes = usePermission("issue_types.manage");
  const { onOpenChange } = useEntitySelector();
  const navigate = useAppNavigate();
  return useMemo(
    () =>
      canManageTypes
        ? {
            label: "Edit",
            onClick: () => {
              onOpenChange(false);
              navigate.push(settingsPath);
            },
          }
        : undefined,
    [canManageTypes, navigate, onOpenChange, settingsPath],
  );
}
